import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { paymentHistory } from '../../apis/payment';
import Loading from '../../components/Loading';
import HistoryItem from './Row';
import BoxEmpty from '../../components/Empty';
import './transaction.scss';
import UsersUsedProduct from '../../components/Product/UsersUsedProduct';

const Transaction = () => {
  const [loading, setLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [openUsersUsedProduct, setOpenUsersUsedProduct] = useState(false);
  const [transferCode, setTransferCode] = useState(null);

  const getPaymentHistory = () => {
    setLoading(true);
    paymentHistory()
      .then((res) => setHistoryData(res?.data || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getPaymentHistory();
  }, []);

  return (
    <Box className='walletHistory'>
      {loading ? (
        <Loading fullHeight={false} />
      ) : historyData.length === 0 ? (
        <BoxEmpty />
      ) : (
        <Box>
          <Typography color='text.dark' fontWeight='bold' mt={2} pb={1}>
            تاریخچه تراکنش‌ها
          </Typography>
          {historyData?.map((item, index) => (
            <HistoryItem
              key={item.paymentCode}
              historyItem={item}
              setOpenUsersUsedProduct={setOpenUsersUsedProduct}
              setTransferCode={setTransferCode}
              lastItem={index + 1 === history.length}
            />
          ))}
        </Box>
      )}

      <UsersUsedProduct
        openUsersUsedProduct={openUsersUsedProduct}
        closeDialog={() => setOpenUsersUsedProduct(false)}
        transferCode={transferCode}
      />
    </Box>
  );
};

export default Transaction;
